import { useContext } from 'react';
import { AuthContext } from '../providers';

export enum AppPermissions {
  HUDSON_ADJ = 'HUDSON_ADJ',
}

export function hasCrudPermission(userPermissions: string[], permission: string) {
  return ['C_', 'R_', 'U_', 'D_'].some((prefix) =>
    userPermissions.includes(`${prefix}${permission}`)
  );
}

export function useUserHasPermission(permission: string) {
  const { userPermissions } = useContext(AuthContext);
  return hasCrudPermission(userPermissions || [], permission);
}
